module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hj2a4"))).then(() => parcelRequire('d0iPb'));